import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Desktop from "../../components/Desktop";
import Mobile from "../../components/Mobile";
import { connect } from "react-redux";
import { getSettings } from "../../services/settings/actions";
import { getAllLanguages } from "../../services/languages/actions";
import { getUserNotifications } from "../../services/alert/actions";
import { getFCMTokenAfterPermission } from "../../init-fcm";
import { saveNotificationToken } from "../../services/notification/actions";
import { shouldShowMobileApp } from "../helpers/appRouting";

const App = (props) => {
  const { settings, languages, getSettings, getAllLanguages } = props;

  const dispatch = useDispatch();
  const initialized = useRef(false);
  const swListenerAttached = useRef(false);

  const user = useSelector((state) => state.user.user);

  /**
   * 🔐 Silent FCM sync (SAFE)
   */
  useEffect(() => {
    if (!user?.success) return;
    if (initialized.current) return;

    initialized.current = true;

    if (localStorage.getItem("enablePushNotification") !== "true") return;

    const syncFCM = async () => {
      const token = await getFCMTokenAfterPermission();
      if (!token) return;

      dispatch(
        saveNotificationToken(token, user.data.id, user.data.auth_token)
      );

      dispatch(
        getUserNotifications(user.data.id, user.data.auth_token)
      );
    };

    syncFCM();
  }, [dispatch, user?.success]);

  /**
   * 📩 ONE global SW message listener
   */
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (!user?.success) return;
    if (swListenerAttached.current) return;

    swListenerAttached.current = true;

    const handler = (event) => {
      if (event.data?.type !== "ALERT_NOTIFICATION_RECEIVED") return;

      dispatch(
        getUserNotifications(user.data.id, user.data.auth_token)
      );
    };

    navigator.serviceWorker.addEventListener("message", handler);

    return () => {
      navigator.serviceWorker.removeEventListener("message", handler);
      swListenerAttached.current = false;
    };
  }, [dispatch, user?.success]);

  /**
   * ⚙️ Settings & languages (unchanged)
   */
  useEffect(() => {
    if (Object.keys(settings).length === 0) {
      getSettings();
    }

    if (languages && languages.length === 0) {
      getAllLanguages();
    }
  }, [settings, languages, getSettings, getAllLanguages]);

  const showMobile = shouldShowMobileApp({ user });

  return (
    <>
      {showMobile ? (
        <Mobile languages={languages} />
      ) : (
        <Desktop languages={languages} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings.settings,
  user: state.user.user,
  notification_token: state.notification_token.notification_token,
  languages: state.languages.languages,
});

export default connect(mapStateToProps, {
  getSettings,
  getAllLanguages,
  saveNotificationToken,
})(App);
